<template>
  <div id='' style='' class='gPageBorder'>
    <el-form class='gForm' label-position="right" ref="firm" :rules='rules' label-width="12.5%" :model='firm'>
      <el-form-item :label="$t('app_firm')" prop='name'>
        <el-input v-model="firm.name" placeholder=""></el-input>
      </el-form-item>
      <el-form-item :label="$t('app_contact')" prop='contact'>
        <el-input v-model="firm.contact" placeholder=''></el-input>
      </el-form-item>
      <el-form-item :label="$t('app_contactPhone')" prop='tel'>
        <el-input v-model="firm.tel" placeholder=''></el-input>
      </el-form-item>
      <el-form-item :label="$t('app_addres')" prop='addr'>
        <el-input v-model="firm.addr" placeholder=''></el-input>
      </el-form-item>
      <el-form-item>
        <el-button  type='' style='' @click="cancel">{{$t('app_cancel')}}</el-button>
        <el-button  type='primary' style='' @click="save('firm')">{{$t('app_save')}}</el-button>
      </el-form-item>
    </el-form>
   
  </div>
</template>

<style>
</style>

<script>
  export default{
    data () {
      var phoneCheck = (rule, value, callback) => {
        if (!this.isLegalMobile(value)) {
          callback(new Error(this.$t('app_phoneIllegal')));
        } else {
          callback()
        }
      }
      return {
        fatherList: [],
        firm: {
          name: '',
          father: '',
          contact: '',
          tel: '',
          addr: '',
          config: {}
        },
        rules: {
          name: [
            { required: true, message: this.$t('app_inputName'), trigger: 'blur' }
          ],
          contact: [
            { required: true, message: this.$t('app_inputContact'), trigger: 'blur' }
          ],
          tel: [
            { required: true, message: this.$t('app_inputTruePhone'), trigger: 'blur'/*, validator: phoneCheck*/}
          ],
          addr: [
            { required: true, message: this.$t('app_inputAddr'), trigger: 'blur' }
          ]
        }
      }
    },
    methods: {
      isLegalMobile (tel) {
        var sMobile = tel
        var regex = "^((13[0-9])|(14[5|7])|(15([0-3]|[5-9]))|(18[0,5-9]))\\d{8}$"
        var re = new RegExp(regex, 'g') 
        if(!(re.test(sMobile))){
          return false
        } else {
          return true
        }
      },
      newfirm () {
        this.loading = 1
        this.$addFirm(this.firm.name, this.firm.contact, this.firm.tel, this.firm.addr, (res) => {
          this.loading = 0
          if (res.status === 200) {
            this.$router.go(-1)
          } else {
            this.$message.error(res.message)
          }
        }, () => {
          // error
          this.loading = 0
        })
      },
      editfirm () {
        var data = this.config.data
        // console.log(this.firm)
        this.loading = 1
        this.$editFirm(data.manufid, this.firm.name, this.firm.contact, this.firm.tel, this.firm.addr, data.createtime, (res) => {
          this.loading = 0
          if (res.status === 200) {
            this.$router.go(-1)
          } else {
            this.$message.error(res.message)
          }
        }, () => {
          this.loading = 0
        }) 
      },
      save (name) {
        // console.log(this.firm)
        this.$refs[name].validate((valid) => {
          if (valid) {
            if (this.config.type === 0) {
              this.newfirm()
            } else {
              this.editfirm()
            }
          } else {
            return false
          }
        })
      },
      cancel () {
        this.$router.go(-1)
      },
      fillData (data) {
        console.log(data)
        this.firm.name = data.name
        this.firm.contact = data.contacts
        this.firm.tel = data.tel
        this.firm.addr = data.address
      }
    },
    mounted () {
      this.config = this.$getWObj().editDataConfig
      if (this.config.type === 1) {
        this.fillData(this.config.data)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// newFirm.vue?5aac8ac4